import styled from "styled-components"

export const Experience = styled.div`
  border: 1px solid #e6e6e6;
  padding: 24px;
  border-radius: 12px;
`
